import { RunModel } from 'models/RunModel/RunModel';
import { Area, ICloudStorage } from 'services/Database/CloudStorageService';
import { ST } from '../../../types';
import {
  APIResponse,
  DongleBindResponse,
  DongleStatusResponse,
  EstimatorInterface,
  KeyBindResponse,
  KeyStatusResponse,
} from '../Estimator';
import { logger } from 'services/Logger';

const DELAY = 500;
class DummyServer implements EstimatorInterface {
  private storage: ICloudStorage;

  constructor(cloudStorage: ICloudStorage) {
    this.storage = cloudStorage;
  }
  async checkDongleStatus(_mac: string): Promise<DongleStatusResponse> {
    return { title: 'checkDongle', text: 'demo' };
  }
  async bindDongle(_mac: string): Promise<DongleBindResponse> {
    return { title: 'bindDongle', text: 'success' };
  }
  async checkKeyStatus(_key: string): Promise<KeyStatusResponse> {
    throw new Error('check');
  }
  async bindKey(_key: string): Promise<KeyBindResponse> {
    throw new Error('bind');
  }
  destroy() {}
  async submitRecordData(
    record: RunModel,
    _recordId?: string
  ): Promise<ST.Play> {
    const area = Area.test;
    // upload record data to firebase
    const recordURL = await this.storage.uploadRecord(record.recordData!, area);
    logger.debug(`Uploaded record to ${recordURL}`);
    if (record.localVideoUri) {
      const videoURL = await this.storage.uploadVideo(
        record.deviceId,
        record.recordId,
        false,
        area
      );
      logger.debug(`Uploaded video to ${videoURL}`);
    }

    await new Promise((resolve) => setTimeout(resolve, DELAY));

    throw new Error("Nah, didn't work!");
  }

  deleteUser(): Promise<APIResponse> {
    throw new Error('nah!');
  }

  deleteRun(
    _deviceId: string,
    _recordId: string,
    _area?: Area
  ): Promise<APIResponse> {
    throw new Error('nah!');
  }
}

export default DummyServer;
